import { defineStore } from 'pinia';
import storage from 'store'
import {getAgentInfo,updateAgentInfo,login,logout} from '@/api/agent'
import useAsyncRouter from '@/stores/async-router';
const useAgent = defineStore({
    id:'agent',
    state(){  // 存放的就是模块的变量
        return{
            agentInfo:{},
        }
    },

    getters:{ // 相当于vue里面的计算属性，可以缓存数据
        
    },

    actions:{ // 可以通过actions 方法，改变 state 里面的值。
        GetAgentInfo(){
            return new Promise((resolve, reject) => {
                getAgentInfo().then(response => {
                    const result = response.result;
                    this.agentInfo = result;
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },

        UpdateAgentInfo(values){
            return new Promise((resolve, reject) => {
                updateAgentInfo(values).then(response => {
                    this.agentInfo['avatar'] = values['avatar'];
                    this.agentInfo['nickname'] = values['nickname'];
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },

        //登录
        Login(values){
            return new Promise((resolve, reject) => {
                login(values).then(response => {
                    const result = response.result;
                    storage.set('token', result);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },

        //退出登录
        Logout(){
            return new Promise((resolve) => {
                logout().then((res) => {
                    storage.remove('token');

                    const asyncRouterStore = useAsyncRouter();
                    asyncRouterStore.addRouters = [];
                    
                    resolve();
                })
            })
        }
    }
})

export default useAgent;